<template>
    <div class="grcform">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>
    <GrcDialog ref="Dialog"
        v-on:popupopened="SetPopupRef('Dialog')"
        v-on:popupclosed="SetPopupRef('')"
    ></GrcDialog>

    <div style="width:100%; box-sizing:border-box; padding-bottom: 0px; margin-bottom: 20px; display: inline-block;">
      <div style="width:100%; box-sizing:border-box;">
            <div class="igeny_pageheader">
                <div class="igeny_pageheader_col1">
                    <div class="grc_sectionheader" style="margin-top:0px;">
                        <h2 class="painted_header_h2 color3"><span><b>Ellátás igénylés</b></span></h2>
                    </div>
                </div>
                <div class="igeny_pageheader_col2">
                    <span class="painted_linkbutton2 color4"><span>{{UgyfelNev}}</span></span>
                </div>
            </div>

      </div>
    </div>

    <div style="width:100%; box-sizing:border-box; text-align:left;" v-show="IsEnabled==0" v-html="DisabledText">
        
    </div>

    <div style="width:100%; box-sizing:border-box; text-align:left;" v-show="(IsEnabled==1)&&(MainStep==0)">
        <div style="width:100%; box-sizing:border-box; text-align:justify;" v-html="MainStep0_infotext">
            
        </div>

        <div class="btncont" style="margin-top:30px;">

            <span @click="GoTo_MainStep(1)" class="painted_linkbutton2 color3"><span>Igény benyújtás<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>                    

        </div>

    </div>


    <div style="width:100%; box-sizing:border-box;" v-show="(IsEnabled==1)&&(MainStep==1)">
      <div style="padding-bottom: 20px; width:100%; box-sizing:border-box;">

        <div class="igeny_pagecontent">

            <div class="StepProgress_cont">
                <GrcStepProgress ref="StepProgress" />
            </div>

            <div class="innerform_cont" v-show="innerform==5">
                <span class="painted_linkbutton2 color4"><span>Igényelt vizsgálat</span></span>
                <br><br>

                <div class="innerform_col50">

                    <div class="longlabel" style="margin-bottom:20px;">
                        Kérjük adja meg milyen vizsgálatot szeretne igénybe venni (többet is jelölhet)?
                    </div>

                    <table style="width:100%; margin-bottom:10px;" cellspacing="0" cellpadding="0">
                    <tr v-for="(ellcsopitem, ellcsopindex)  in ELLATASCSOPORT" v-bind:key="ellcsopindex">
                        <td style="width:45px;" valign="top">
                            <GrcCheckboxMobile ref="chkEllCsop" v-on:valuechanged="chkEllCsopChanged(ellcsopindex)" :grc_readonly="ellcsopitem.Engedelyezett==1?'false':'true' " />
                        </td>
                        <td valign="top" :class="[ellcsopitem.Engedelyezett==1 ? 'ellcsop_jarobeteg_megnev' : 'ellcsop_jarobeteg_megnev_disabled']">
                            {{ellcsopitem.Megnevezes}}<span class="btnEllCsopInfo" v-show="ellcsopitem.Engedelyezett!=-10" @click="btnEllCsopInfo_click(ellcsopitem.ID)"><i class="fas fa-info-circle"></i></span>
                        </td>
                    </tr>
                    </table>

                    <div style="width:100%; box-sizing:border-box; padding-left:45px;" v-show="ShowJarobeteg">

                        <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                        <tr v-for="(jaroitem, jaroindex)  in JAROBETEGELLATAS" v-bind:key="jaroindex">
                            <td style="width:45px;" valign="top">
                                <GrcCheckboxMobile ref="chkJarobeteg" :grc_readonly="jaroitem.Engedelyezett==1?'false':'true' " />
                            </td>
                            <td valign="top" :class="[jaroitem.Engedelyezett==1 ? 'ellcsop_jarobeteg_megnev' : 'ellcsop_jarobeteg_megnev_disabled']">
                                {{jaroitem.Megnevezes}}
                            </td>
                        </tr>
                        </table>
                    </div>
                </div>
                <div class="innerform_col50">
                    <div class="VizsgalatInfoText" v-html="VizsgalatInfoText" v-show="VizsgalatInfoText!=''"></div>
                </div>

                <div class="longlabel" style="margin-top:20px;">{{txtVizsgalatLeiras_labeltext}}</div>
                <GrcTextArea ref="txtVizsgalatLeiras"
                grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="200px" 
                grc_areaheight="150px"
                style="margin-top:10px;"
                />

                <div style="width:100%; box-sizing:border-box;" v-show="SelectedVizsgTipus==1">
                    <div class="longlabel" style="margin-bottom:10px; margin-top: 20px;">
                        Kérjük adja meg, hogy első vizsgálatról, vagy kontrollról esetleg szűrővizsgálatról van szó!
                    </div>


                    <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                    <tr>
                        <td style="width:45px;" valign="top">
                            <GrcCheckboxMobile ref="chkKivizsgalas" v-on:valuechanged="chkKivKontSzurChanged(1)" />
                        </td>
                        <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px; height: 30px; font-weight: normal;">
                            <b>Kivizsgálás:</b> Az adott betegséggel kapcsolatos korábban még nem volt ilyen vizsgálatom
                        </td>
                    </tr>
                    <tr>
                        <td style="width:45px;" valign="top">
                            <GrcCheckboxMobile ref="chkKontrol" v-on:valuechanged="chkKivKontSzurChanged(2)" />
                        </td>
                        <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px; height: 30px; font-weight: normal;">
                            <b>Kontroll vizsgálat:</b> Már vizsgáltak, kezeltek az adott betegséggel kapcsolatosan most ellenőrző vizsgálatra van szükségem
                        </td>
                    </tr>
                    <tr>
                        <td style="width:45px;" valign="top">
                            <GrcCheckboxMobile ref="chkSzures" v-on:valuechanged="chkKivKontSzurChanged(3)" />
                        </td>
                        <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px; height: 30px; font-weight: normal;">
                            <b>Szűrés célú  vizsgálat:</b> Konkrét panaszom nincs, de megelőzési céllal szeretnék részt venni a vizsgálaton
                        </td>
                    </tr>

                    </table>
                </div>

                <div style="width:100%; box-sizing:border-box; margin-top:20px;" v-show="SelectedVizsgTipus==2">

                    <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                    <tr>
                        <td style="width:45px;" valign="top">
                            <GrcCheckboxMobile ref="chkMutet_MagamIntezem" v-on:valuechanged="chkMutet_changed(1)" />
                        </td>
                        <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px; height: 30px; font-weight: normal;">
                            <span style="font-weight:500;">A műtétet magam intézem. Eldöntött az operáló orvos személye és az intézmény is.</span>

                            <table style="width:100%; margin-bottom:20px; margin-top:20px;" cellspacing="0" cellpadding="0" v-show="MutetIntezTipus==1">
                            <tr>
                                <td style="width:45px;" valign="top">
                                    <GrcCheckboxMobile ref="chkMutet_MagamIntezem_sub1" />
                                </td>
                                <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px; height: 30px; font-weight: normal;">
                                    Tudomásul veszem, hogy a műtéti költségeket előre kell finanszíroznom, azokat az erre rendelkezésre álló keretem erejéig a Biztosító a benyújtott számla alapján utólag téríti meg.
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" valign="top" style="font-weight:500; padding-top:20px; color:coral;">
                                    A harmadik lépésben fel kell töltenie a műtétre vonatkozó orvosi javaslatot, valamint az árajánlatot is. Kérjük ezeket készítse elő. Amennyiben nem rendelkezik árajánlattal az igény bejelentése előtt szerezze azt be!                                    
                                </td>
                            </tr>
                            </table>

                        </td>
                    </tr>
                    <tr>
                        <td style="width:45px;" valign="top">
                            <GrcCheckboxMobile ref="chkMutet_Ella" v-on:valuechanged="chkMutet_changed(2)" />
                        </td>
                        <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px; height: 30px; font-weight: normal;">
                            <span style="font-weight:500;">A műtétet tervezem, az ellátásszervező segítségével kívánom megszervezni</span>

                            <table style="width:100%; margin-bottom:20px; margin-top:20px;" cellspacing="0" cellpadding="0" v-show="MutetIntezTipus==2">
                            <tr v-show="chkMutet_Ella_Sub1_visible==1">
                                <td style="width:45px;" valign="top">
                                    <GrcCheckboxMobile ref="chkMutet_Ella_sub1" />
                                </td>
                                <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px; height: 30px; font-weight: normal;">
                                    A műtéthez a leendő operáló orvosnak előzetesen meg kell vizsgálnia Önt. Ennek költségeire nem terjed ki a biztosítása. Vállalom ennek költségeit (15-30 000 Ft).
                                </td>
                            </tr>
                            <tr>
                                <td style="width:45px;" valign="top">
                                    <GrcCheckboxMobile ref="chkMutet_Ella_sub2" />
                                </td>
                                <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px; height: 30px; font-weight: normal;">
                                    Tudomásul veszem, hogy a műtéti költségeket előre kell finanszíroznom, azokat az erre rendelkezésre álló keretem erejéig a Biztosító a benyújtott számla alapján utólag téríti meg.
                                </td>
                            </tr>
                            </table>

                        </td>
                    </tr>
                    </table>
                </div>




                <div class="btncont" style="margin-top:30px;">

                    <span @click="GoTo_MainStep(0)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>
                    <span @click="btnStepTo(10)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>                    

                </div>


            </div>




            <div class="innerform_cont" v-show="innerform==10">
                <span class="painted_linkbutton2 color4"><span>Panaszok leírása</span></span>
                <br><br>

                <div class="longlabel">
                    Panaszok kezdete:
                    <br><span style="font-weight:normal;">(az az időpont, amikor először tapasztaltam magamon a tüneteket ezzel a betegséggel kapcsolatban)</span>
                </div>
                <GrcDate ref="txtPanaszokKezdete" v-model="PanaszokKezdete" grc_dateformat="ymd" grc_sep="." 
                grc_labeltext="&nbsp;" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                v-on:grc-keydown-enter="SetControlToFocus('txtPanaszLeiras');"
                v-on:dropdownopened="SetPopupRef('txtPanaszokKezdete')"
                v-on:dropdownclosed="SetPopupRef('')"
                style="max-width:300px;"
                />

                <GrcTextArea ref="txtPanaszLeiras"
                grc_labeltext="Panaszok rövid leírása (min. 30 karakter):" grc_labelmode="above" grc_labelwidth="200px" 
                grc_areaheight="150px"
                style="margin-top:20px;"
                />


                <div class="btncont" style="margin-top:30px;">
                    <span @click="btnStepTo(5)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnStepTo(20)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>


                </div>
            </div>


            <div class="innerform_cont" v-show="innerform==20">
                <span class="painted_linkbutton2 color4"><span>Beutalók, orvosi javaslatok feltöltése</span></span>
                <br><br>


                    <div class="general_infotext" style="margin: 10px 0px 20px 0px; text-align:justify;" v-show="!((ELLCSOPSELECTED=='6')&&(MutetIntezTipus==1))">
                        Az ön által igényelt egészségügyi ellátást akkor veheti igénybe, hogy ha megfelelő háziorvosi vagy szakorvosi javaslata van. 
                        Kérjük a vonatkozó orvosi javaslatot (ambuláns lapok, zárójelentések, beutalók) töltse fel. 
                        Amennyiben a dokumentumai jelszóval védettek, kérjük a jelszót, jelszavakat a megjegyzés mezőben adja meg.
                    </div>

                    <div class="general_infotext" style="margin: 10px 0px 20px 0px; text-align:justify;" v-show="(ELLCSOPSELECTED=='6')&&(MutetIntezTipus==1)">
                        Az ön által igényelt egészségügyi ellátást akkor veheti igénybe, hogy ha megfelelő háziorvosi vagy szakorvosi javaslata van. 
                        Kérjük a vonatkozó orvosi javaslatot (ambuláns lapok, zárójelentések, beutalók) töltse fel. 
                        Tekintettel arra, hogy Ön a műtét szervezését önmaga végzi el, kérjük töltse fel a vonatkozó árajánlatot, 
                        vagy amennyiben a műtét már megtörtént, az arra vonatkozó számlát is. 
                        Amennyiben a dokumentumai jelszóval védettek, kérjük a jelszót, jelszavakat a megjegyzés mezőben adja meg.
                    </div>

                    <div class="kontrol_info" v-show="ShowKontrolInfo" v-html="KontrolInfoText"></div>

                    <div style="width:100%; box-sizing:border-box; margin-top: 20px;">
                        <div class="docs_label">- Orvosi dokumentáció, javaslat -</div>
                        <GrcDocMultiSelect ref="docs" :grc_allowed_extensions="AllowedExtensions" :grc_maxfiles="MaxFiles" :grc_shownoti="ShowNoti" />
                    </div>

                    <div style="width:100%; box-sizing:border-box; margin-top:20px;" v-show="(ELLCSOPSELECTED=='6')&&(MutetIntezTipus==1)">
                        <div class="docs_label">- Árajánlat, számla feltöltése -</div>
                        <GrcDocMultiSelect ref="docs2" :grc_allowed_extensions="AllowedExtensions" :grc_maxfiles="MaxFiles" :grc_shownoti="ShowNoti" />
                    </div>
   

                <div class="btncont" style="margin-top:30px;">
                    <span @click="btnStepTo(10)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnStepTo(30)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>

                </div>
            </div>


            <div class="innerform_cont" v-show="innerform==30">
                <span class="painted_linkbutton2 color4"><span>Időpont foglalás</span></span>
                <br><br>

                <div class="idopont_checkbox_cont">

                    <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                    <tr>
                        <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkIdopont1" v-on:valuechanged="chkIdopontClick(1)" 
                        v-show="(ELLCSOPSELECTED!='6')"
                        /></td>
                        <td valign="top" style="text-align:justify; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px;">
                            <span v-show="(ELLCSOPSELECTED!='6')">
                                <span style="font-weight:500; text-decoration:none; color:var(--premblue);">Már van időpontom:</span> Az igényelt ellátásra már foglaltam magamnak időpontot. Csak a biztosító jóváhagyására és finanszírozására van szükségem.
                            </span>

                            <div class="igenyles_longlabel" style="margin-top: 20px;" v-show="IdopontCheckboxSelected==1">
                                Az egészségügyi szolgáltató neve és címe<br>(pl. Borostyán Egészségház, 1023 Budapest Egészség utca 10.):
                            </div>

                            <GrcText ref="txtVanIdopont_Szolgaltato"
                            grc_labeltext="&nbsp;"
                            grc_placeholder="..."
                            grc_labelmode="nolabel" grc_labelwidth="300px" 
                            v-on:grc-keydown-enter="SetControlToFocus('txtVanIdopont_Orvos');"
                            style="margin-bottom:10px; margin-top:10px; max-width:600px;"
                            v-show="IdopontCheckboxSelected==1"
                            />

                            <div class="igenyles_longlabel" style="margin-top: 20px;" v-show="IdopontCheckboxSelected==1">
                                Az ellátást végző orvos neve<br>(nem kötelező):
                            </div>

                            <GrcText ref="txtVanIdopont_Orvos"
                            grc_labeltext="&nbsp;"
                            grc_placeholder="..."
                            grc_labelmode="nolabel" grc_labelwidth="300px" 
                            v-on:grc-keydown-enter="SetControlToFocus('txtVanIdopont_Datum');"
                            style="margin-bottom:10px; margin-top:10px; max-width:600px;"
                            v-show="IdopontCheckboxSelected==1"
                            />


                            <div style="width:100%; box-sizing:border-box;" v-show="IdopontCheckboxSelected==1">

                            <div class="igenyles_longlabel" style="margin-bottom: 10px;" v-show="(ELLCSOPSELECTED!='6')">
                                A foglalt időpont dátuma, amikor a szolgáltatást igénybe fogja venni<br>(pl. 2020.12.13-án 10. 30-ra megy hasi ultrahang vizsgálatra):
                            </div>
                           

                                <GrcDate ref="txtVanIdopont_Datum" v-model="VanIdopont_Datum" grc_dateformat="ymd" grc_sep="." 
                                grc_labeltext="Dátum:" grc_labelmode="" grc_labelwidth="210px" grc_readonly="false"
                                v-on:grc-keydown-enter="SetControlToFocus('cboVanIdopont_Ora');"
                                v-on:dropdownopened="SetPopupRef('txtVanIdopont_Datum')"
                                v-on:dropdownclosed="SetPopupRef('')"
                                style="display:inline-block; width:210px; vertical-align: top; margin-right:10px; margin-bottom:8px;"
                                />

                                <GrcCombo ref="cboVanIdopont_Ora" v-model="VanIdopont_Ora" grc_labeltext="Óra:"
                                grc_labelmode="above" grc_labelwidth="100px" grc_dropdownminwidth="300"  
                                grc_keyfield="id" grc_displayfield="Megnevezes"
                                grc_readonly="false"
                                v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                                v-on:dropdownopened="SetPopupRef('cboVanIdopont_Ora')"
                                v-on:dropdownclosed="SetPopupRef('')"
                                v-on:grc-keydown-enter="SetControlToFocus('cboVanIdopont_Perc');"
                                style="display:inline-block; width:100px; vertical-align: top; margin-right:10px; margin-bottom:8px;"
                                v-show="(ELLCSOPSELECTED!='6')"
                                />

                                <GrcCombo ref="cboVanIdopont_Perc" v-model="VanIdopont_Perc" grc_labeltext="Perc:"
                                grc_labelmode="above" grc_labelwidth="100px" grc_dropdownminwidth="300"  
                                grc_keyfield="id" grc_displayfield="Megnevezes"
                                grc_readonly="false"
                                v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                                v-on:dropdownopened="SetPopupRef('cboVanIdopont_Perc')"
                                v-on:dropdownclosed="SetPopupRef('')"
                                v-on:grc-keydown-enter="SetControlToFocus('');"
                                style="display:inline-block; width:100px; vertical-align: top; margin-bottom:8px;"
                                v-show="(ELLCSOPSELECTED!='6')"
                                />
                            </div>



                        </td>
                    </tr>
                    </table>

                    <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                    <tr>
                        <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkIdopont2_1" v-on:valuechanged="chkIdopontClick(2)" 
                        v-show="(ELLCSOPSELECTED!='6')" /></td>
                        <td valign="top" style="text-align:justify; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px;">
                            <span v-show="(ELLCSOPSELECTED!='6')">
                                <span style="font-weight:500; text-decoration:none; color:var(--premblue);">Még nincs időpontom</span> 
                            </span>

                            <div class="general_infotext"  v-show="IdopontCheckboxSelected==2" style="margin:10px 0px;">
                                Kérjük adja meg a várost ahol a szolgáltatást elsősorban igénybe szeretné venni! Budapest esetében kiválaszthatja az Ön által preferált kerületet is.
                            </div>

                            <GrcAutoComplete ref="txtVarosOnline" v-model="txtVarosOnline" grc_labeltext="Város:" v-show="IdopontCheckboxSelected==2"
                            grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300" grc_dropdownmaxwidth="500"  
                            grc_keyfield="id" grc_displayfield="Megnevezes" grc_dropdownheight="150"
                            grc_readonly="false"
                            v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                            v-on:dropdownopened="SetPopupRef('txtVarosOnline')"
                            v-on:dropdownclosed="SetPopupRef('')"
                            v-on:grc-keydown-enter="SetControlToFocus('');"
                            style="margin-bottom:20px; max-width:600px; margin-top:10px;"
                            />

                        </td>
                    </tr>
                    </table>
        
                </div>


                <div class="btncont" style="margin-top:30px;">
                    <span @click="btnStepTo(20)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnStepTo(35)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>

                </div>
            </div>



            <div class="innerform_cont" v-show="innerform==35">
                <span class="painted_linkbutton2 color4"><span>Időpont foglalás</span></span>
                <br><br>

                <div class="idopont_checkbox_cont">

                    <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0" v-show="OnlineLehet">
                    <tr>
                        <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkIdopont2" v-on:valuechanged="chkIdopontClick_2(1)" 
                        v-show="(ELLCSOPSELECTED!='6')"
                        /></td>
                        <td valign="top" style="text-align:justify; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px;">
                            <span v-show="(ELLCSOPSELECTED!='6')">
                                <span style="font-weight:500; text-decoration:none; color:var(--premblue);">Választok a felajánlott szolgáltatók és időpontok közül:</span> Az ellátásszervező egy linket küld majd az e-mail címemre. Erre kattintva magam választom ki, hogy hová és mikor akarok elmenni az adott vizsgálatra
                            </span>
                        </td>
                    </tr>
                    </table>
                  
        
                    <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                    <tr>
                        <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkIdopont3" v-on:valuechanged="chkIdopontClick_2(2)" 
                        v-show="(ELLCSOPSELECTED!='6')&&(OnlineLehet==true)" /></td>
                        <td valign="top" style="text-align:justify; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#222;padding-top: 0px;">
                            <span v-show="(ELLCSOPSELECTED!='6')">
                                <span style="font-weight:500; text-decoration:none; color:var(--premblue);">Ellátásszervezőre bízom:</span> Megadom azokat az idősávokat és azt a helyszínt ami alkalmas számomra a szolgáltatás igénybevételére. 
                                Az ellátásszervező a foglalást ezen adatok alapján megteszi és erről számomra tájékoztatást küld.
                            </span>
                            
                            <div class="general_infotext"  v-show="IdopontCheckboxSelected_2==2" style="margin:10px 0px;">
                                Kérjük adja meg a várost ahol a szolgáltatást elsősorban igénybe szeretné venni! Budapest esetében kiválaszthatja az Ön által preferált kerületet is.
                            </div>

                            <GrcAutoComplete ref="txtVarosEllatas" v-model="txtVarosEllatas" grc_labeltext="Város:" v-show="IdopontCheckboxSelected_2==2"
                            grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="300" grc_dropdownmaxwidth="500"  
                            grc_keyfield="id" grc_displayfield="Megnevezes" grc_dropdownheight="150"
                            grc_readonly="false"
                            v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                            v-on:dropdownopened="SetPopupRef('txtVarosEllatas')"
                            v-on:dropdownclosed="SetPopupRef('')"
                            v-on:grc-keydown-enter="SetControlToFocus('');"
                            style="margin-bottom:20px; max-width:600px; margin-top:10px;"
                            />

                            <div class="general_infotext" style="margin-top:20px;" v-show="IdopontCheckboxSelected_2==2">Amennyiben megjegyzést kíván fűzni a helyszínhez, van preferált szolgáltatója vagy olyan, akihez menni szeretne stb. tegye meg itt!</div>
                            <GrcTextArea ref="txtVarosEllatasMegjegyzes"
                            grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="200px" 
                            grc_areaheight="100px"
                            style="margin-top:10px;"
                            v-show="IdopontCheckboxSelected_2==2"
                            />


                        </td>
                    </tr>
                    </table>
                </div>


                <div class="btncont" style="margin-top:30px;">

                    <span @click="btnStepTo(30)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnStepTo(40)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>

                </div>
            </div>



            <div class="innerform_cont" v-show="innerform==40">
                <span class="painted_linkbutton2 color4"><span>Időpontok megadása</span></span>
                <br><br>

                <div class="infotext" style="margin-bottom:10px;">
                    <div class="general_infotext" style="margin:10px 0px; text-align:justify;" v-show="(ELLCSOPSELECTED!='6')&&(ELLCSOPSELECTED!='9')">
                        Adjon meg legalább 5 különböző napot és naponta egy három órás idősávot, amikor alkalmas Önnek a szolgáltatás igénybevétele. 
                        Egyszerre több napot is kijelölhet a kezdő és a záró dátum megadásával. 
                        Legkorábbi kezdő dátum amit megadhat, a bejelentést követő 2. nap lehet.
                    </div>

                    <div class="general_infotext" style="margin:10px 0px; text-align:justify;" v-show="(ELLCSOPSELECTED=='6')||(ELLCSOPSELECTED=='9')">
                        Adjon meg legalább 5 különböző napot, amikor alkalmas Önnek a szolgáltatás igénybevétele. 
                        Egyszerre több napot is kijelölhet a kezdő és a záró dátum megadásával. 
                        Legkorábbi kezdő dátum amit megadhat, a bejelentést követő 2. nap lehet.
                    </div>

                </div>

                <div class="general_infotext" style="text-align:center; text-align: center; margin-bottom: 10px; font-weight:500;" >
                    <span class="painted_linkbutton2 color4"><span><i class="fal fa-calendar-alt" style="margin-right:10px;"></i>Időpontok listája</span></span>
                </div>

                <div class="general_infotext" style="text-align:center; text-align: center; margin-bottom: 20px;" v-show="Idopontok.length==0&&IdopontInputMode==0">
                    A lista még üres
                </div>

                <div class="idopont_cont" v-show="Idopontok.length>0">
                    <div class="idopont_item" v-for="(idopont, idopontindex) in Idopontok">
                        <table class="idopont_item_text" cellspacing="0" cellpadding="0">
                            <tr>
                                <td>
                                    <span style="margin-right:20px;">
                                        {{idopont.DatumTol}} - {{idopont.DatumIg}}
                                    </span>
                                    <span v-show="(ELLCSOPSELECTED!='6')&&(ELLCSOPSELECTED!='9')">
                                        {{idopont.TimeTol}} - {{idopont.TimeIg}}
                                    </span>
                                </td>
                                <td style="width:30px; text-align:center; cursor:pointer; color:red;" @click="IdopontTorles(idopontindex)">
                                    <i class="far fa-times-circle"></i>
                                </td>

                            </tr>
                        </table>
                    </div>
                </div>

                <div class="btncont" style="text-align: center; margin: 10px 0px;" v-show="IdopontInputMode==0">
                    <span @click="btnIdopont_Uj_click" class="painted_linkbutton2 color3" style="margin:4px;"><span><i class='fal fa-plus' style="margin-right:10px;"></i>Új időpont hozzáadás</span></span>
                </div>


                <div ref="IdopontInput" class="UjIdopont_cont" v-show="IdopontInputMode>0">

                    <div class="IdopontInput_row">
                
                        <GrcDate ref="txtDatumTol" v-model="txtDatumTol" grc_dateformat="ymd" grc_sep="." 
                        grc_labeltext="Kezdő dátum:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                        grc_onlydropdown="true"
                        v-on:grc-keydown-enter="SetControlToFocus('txtDatumIg');"
                        v-on:dropdownopened="SetPopupRef('txtDatumTol')"
                        v-on:onlydropdownclosed="txtDatumTol_OnInput"
                        
                        class="UjIdopont_mezo"
                        />

                        <GrcDate ref="txtDatumIg" v-model="txtDatumIg" grc_dateformat="ymd" grc_sep="." 
                        grc_labeltext="Záró dátum:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                        grc_onlydropdown="true"
                        v-on:grc-keydown-enter="SetControlToFocus('cboTimeTol');"
                        v-on:dropdownopened="SetPopupRef('txtDatumIg')"
                        v-on:onlydropdownclosed="txtDatumIg_OnInput"
                        class="UjIdopont_mezo"
                        />
                    </div>

                    <div class="IdopontInput_row" v-show="(ELLCSOPSELECTED!='6')&&(ELLCSOPSELECTED!='9')">

                        <GrcCombo ref="cboTimeTol" v-model="TimeTol" grc_labeltext="Kezdő időpont:"
                        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="0"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        grc_readonly="false"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('cboTimeTol')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('cboTimeIg');"
                        class="UjIdopont_mezo"
                        />

                        <GrcCombo ref="cboTimeIg" v-model="TimeIg" grc_labeltext="Záró időpont:"
                        grc_labelmode="above" grc_labelwidth="80px" grc_dropdownminwidth="0"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        grc_readonly="false"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('cboTimeIg')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('');"
                        class="UjIdopont_mezo"
                        />
                    </div>

                    <div class="btncont" style="margin-top:30px;">

                        <span @click="btnIdopontMentes" class="painted_linkbutton2 color3" style="margin:4px;"><span><i class='fal fa-check' style="margin-right:10px;"></i>Hozzáadás</span></span>

                        <span @click="btnIdopontMegsem" class="painted_linkbutton2 color7" style="margin:4px;"><span>Mégsem</span></span>

                    </div>

                </div>
    

                <div class="btncont" style="margin-top:50px;" v-show="IdopontInputMode==0">

                    <span @click="btnStepTo(35)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnStepTo(50)" class="painted_linkbutton2 color3" style="margin:4px;"><span>Tovább<i class='fal fa-chevron-right' style="margin-left:10px;"></i></span></span>

                </div>
            </div>



            <div class="innerform_cont" v-show="innerform==50">
                <span class="painted_linkbutton2 color4"><span>Áttekintés és mentés</span></span>
                <br><br>


                <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                    <tr>
                        <td style="text-align:center; font-weight:500; font-size:20px;">{{Osszesito.Igenylo}}</td>
                    </tr>
                    <tr>
                        <td style="text-align:center;padding-top: 10px;"><i>- igénybejelentése -</i></td>
                    </tr>
                </table>

                <div style="width:100%; box-sizing:border-box; font-weight:500; text-align:left; margin: 20px 0px 10px 0px;">
                    Panaszok kezdete: <span style="font-weight:normal;">{{Osszesito.PanaszKezdet}}</span>
                </div>


                <div style="width:100%; box-sizing:border-box; font-weight:500; text-align:left; margin: 20px 0px 10px 0px;">
                    Panaszok rövid leírása:
                </div>
                <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:justify;" v-html="Osszesito.PanaszLeiras"></div>

                <div style="width:100%; box-sizing:border-box; font-weight:500; text-align:left; margin: 20px 0px 10px 0px;">
                    Milyen vizsgálatot szeretne a biztosítása terhére igénybe venni?
                </div>
                <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:justify;" v-html="Osszesito.VizsgalatLeiras"></div>


                <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:left; margin: 20px 0px 10px 0px;" v-show="Osszesito.Varos==''">
                    <span style="font-weight:500;">Időpont foglalás:</span> 
                    {{Osszesito.IdopontMegnevezes}}
                    <br>
                    {{Osszesito.VanIdopont_Szolgaltato}}, {{Osszesito.VanIdopont_Idopont}}
                </div>

                <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:left; margin: 20px 0px 10px 0px;" v-show="Osszesito.Varos!=''">
                    <span style="font-weight:500;">Időpont foglalás:</span> 
                    {{Osszesito.IdopontMegnevezes}}, <span style="font-weight:500;">{{Osszesito.Varos}}</span> 
                    térségében szeretném a szolgáltatást igénybe venni. {{Osszesito.VarosMegjegyzes}}
                </div>

                <div class="osszesito_box_cont">

                        <div class="osszesito_box_col" v-show="Osszesito.IdopontID==3">
                            <div class="osszesito_box_col_header">Idősávok listája:</div>
                            <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:left; padding-left:10px;" v-html="Osszesito.Idosavok"></div>
                        </div>

                        <div class="osszesito_box_col">
                            <div class="osszesito_box_col_header">Feltöltendő fájlok:</div>

                            <div class="osszesito_box_col_content" v-show="Files.length==0">Nem választott ki fájlt</div>

                            <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:left;" v-show="Files.length>0">
                                <div style="width:100%; box-sizing:border-box; font-weight:normal; text-align:left; padding-left:10px;"
                                v-for="(fileitem, fileindex) in Files">{{fileitem.FileName}}</div>
                            </div>
                        </div>

                </div>




                
    

                <div class="btncont" style="margin-top:30px;">

                    <span @click="btnStepTo(40)" class="painted_linkbutton2 color7" style="margin:4px;"><span><i class='fal fa-chevron-left' style="margin-right:10px;"></i>Vissza</span></span>

                    <span @click="btnMentes" class="painted_linkbutton2 color3" style="margin:4px;"><span><i class='fal fa-check' style="margin-right:10px;"></i>Mentés</span></span>

                </div>
            </div>


        </div> <!-- igeny_pagecontent -->

      </div>
    </div>





    
    </div>
</template>

<script>
import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcTajszam from '../GrcComponents/GrcTajszam.vue'
import GrcIrszam from '../GrcComponents/GrcIrszam.vue'
import GrcTextArea from '../GrcComponents/GrcTextArea.vue'
import GrcStepProgress from '../GrcComponents/GrcStepProgress.vue'
import GrcAutoComplete from '../GrcComponents/GrcAutoComplete.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'
import GrcDocMultiSelect from '../GrcComponents/GrcDocMultiSelect.vue'

export default {
  name: 'frmigenyles',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcCheckboxMobile,
      GrcDate,
      GrcTajszam,
      GrcIrszam,
      GrcTextArea,
      GrcStepProgress,
      GrcAutoComplete,
      GrcDocDisplayer,
      GrcDocMultiSelect,

  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmIgenyles_",
          UgyfelID:0,
          UgyfelNev:"",
          Varos:"",
          SzolgaltatasID:0,
          SzolgaltatasNev:"",
          innerform:-1,

          VizsgalatInfoText:"",
          txtVizsgalatLeiras_labeltext:"Kérjük szövegesen is írja le milyen vizsgálatot igényel?",
          SelectedVizsgTipus: 0,
          MutetIntezTipus:0,
          chkMutet_Ella_Sub1_visible:0,

          MinPanaszKezdet:"",
          MaxPanaszKezdet:"",
          DokumentumKotelezo:0,

          PanaszokKezdete:"",
          txtVarosOnline:"",
          txtVarosEllatas:"",

          IdopontCheckboxSelected:-1,
          IdopontCheckboxSelected_2:-1,
          IdopontSelected:-1,

          OnlineLehet:false,

          VanIdopont_Datum:"",
          VanIdopont_Ora:0,
          VanIdopont_Perc:0,

          Files: [],
          MaxWidth:1000,
          MaxHeight:1500,
          MaxFileCount:10,

          txtDatumTol:"",
          txtDatumIg:"",
          TimeTol:0,
          TimeIg:0,

          IdopontInputMode:0,
          Idopontok:[],

          HELYSEGEK:[],

          Osszesito: { Igenylo:"", PanaszKezdet:"", PanaszLeiras:"", VizsgalatLeiras:"", IdopontID:0, IdopontMegnevezes:"", Varos:"", Idosavok:"", 
          VanIdopont_Szolgaltato:"", VanIdopont_Idopont:"", VarosMegjegyzes:"" },

        ELLATASCSOPORT:[],
        JAROBETEGELLATAS:[],
        ShowJarobeteg:false,
        ShowKontrolInfo:false,
        KontrolInfoText:"",
        ELLCSOPSELECTED:"",
        JAROBETEGSELECTED:"",
        EllCsopSelectedText:"",
        JarobetegSelectedText:"",

        AllowedExtensions:"pdf, jpg, png",
        ShowNoti:"false",
        MaxFiles:"-1",

        MinDate: "",
        MaxDate:"",

        IsEnabled:-1,
        DisabledText:"",
        MainStep:0,
        MainStep0_infotext:"",

        
      }
  },
  model: {
  },  
  methods:{

    GoTo_MainStep(pValue)
    {
        this.MainStep = pValue;
        this.scrollToTop();
    },

    async btnEllCsopInfo_click(pID)
    {
        //console.log(pID);
        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          sSelectedEll: ""+pID,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmIgenyles_GetVizsgalatInfoText", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            return;
        }

        this.$refs.GRCDB.HideLoading();

        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), Q.RESULT[0].InfoText);             
        p.height = 500;
        p.width = 600;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },

    txtDatumTol_OnInput(pNewValue)
    {
        this.SetPopupRef('');
        var MD = this.MinDate;
        if (pNewValue != "") { MD = pNewValue; }

        this.$refs.txtDatumIg.SetMinMaxDate(MD, this.MaxDate);

        //console.log("tol: "+pNewValue);
    },

    txtDatumIg_OnInput(pNewValue)
    {
        this.SetPopupRef('');

        var MD = this.MaxDate;
        if (pNewValue != "") { MD = pNewValue; }

        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, MD);

        //console.log("ig: "+pNewValue);
    },

    chkKivKontSzurChanged(pValue)
    {
        if (pValue == 1)
        {
            if (this.$refs.chkKivizsgalas.GetValue() == 1)
            {
                this.$refs.chkKontrol.SetValue(0);
                this.$refs.chkSzures.SetValue(0);
            }
        }

        if (pValue == 2)
        {
            if (this.$refs.chkKontrol.GetValue() == 1)
            {
                this.$refs.chkKivizsgalas.SetValue(0);
                this.$refs.chkSzures.SetValue(0);
            }

            this.ShowKontrolInfo = this.$refs.chkKontrol.GetValue() == 1;
        }

        if (pValue == 3)
        {
            if (this.$refs.chkSzures.GetValue() == 1)
            {
                this.$refs.chkKivizsgalas.SetValue(0);
                this.$refs.chkKontrol.SetValue(0);
            }
        }


    },

    chkMutet_changed(pValue)
    {
        //console.log("chkMutet "+pValue);

        this.MutetIntezTipus = 0;

        if (pValue == 1)
        {
            if (this.$refs.chkMutet_MagamIntezem.GetValue() == 1) 
            { 
                this.MutetIntezTipus = 1;
                if (this.$refs.chkMutet_Ella.GetValue() != 0) { this.$refs.chkMutet_Ella.SetValue(0); }
                return; 
            }
        }

        if (pValue == 2)
        {
            if (this.$refs.chkMutet_Ella.GetValue() == 1)
            { 
                this.MutetIntezTipus = 2;
                if (this.$refs.chkMutet_MagamIntezem.GetValue() != 0) { this.$refs.chkMutet_MagamIntezem.SetValue(0); }
                return;
            }
        }

        if (this.$refs.chkMutet_MagamIntezem.GetValue() == 1) { this.MutetIntezTipus = 1; }
        if (this.$refs.chkMutet_Ella.GetValue() == 1) { this.MutetIntezTipus = 2; }

    },

    async chkEllCsopChanged(pIndex)
    {
        //console.log("ellcsop changed "+pIndex);
        let SelectedList = "";
        let SelectedCount = 0;
        let EgynaposSelected = false;
        let AmbulansSelected = false;


        for(let i=0; i<this.ELLATASCSOPORT.length; i++)
        {
            if (this.$refs.chkEllCsop[i].GetValue() == 1)
            {
                SelectedCount++;
                SelectedList = SelectedList + this.ELLATASCSOPORT[i].ID+",";
                if (this.ELLATASCSOPORT[i].ID == 6) { EgynaposSelected = true; }
                if (this.ELLATASCSOPORT[i].ID == 9) { AmbulansSelected = true; }

            }
        }

        if ((EgynaposSelected) && (SelectedCount > 1))
        {
            this.ShowResult("Egynapos sebészet csak önmagában választható!", 200);
            this.$refs.chkEllCsop[pIndex].SetValue(0);
            return;
        }

        if ((AmbulansSelected) && (SelectedCount > 1))
        {
            this.ShowResult("Ambuláns sebészet csak önmagában választható!", 200);
            this.$refs.chkEllCsop[pIndex].SetValue(0);
            return;
        }

        if (this.ELLATASCSOPORT[pIndex].ID == 7)
        {
            this.ShowJarobeteg = this.$refs.chkEllCsop[pIndex].GetValue() == 1;
        }

        this.SelectedVizsgTipus = 0;

        if ((SelectedList == "6,") || (SelectedList == "9,"))
        {
            this.txtVizsgalatLeiras_labeltext = "Kérjük írja le pontosan milyen műtétet tervez!";

            if (SelectedList == "6,") { this.SelectedVizsgTipus = 2; }
        }
        else
        {
            this.txtVizsgalatLeiras_labeltext = "Kérjük szövegesen is írja le milyen vizsgálatot igényel?";
            if (SelectedList!="") { this.SelectedVizsgTipus = 1; }
        }
        



        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          sSelectedEll: SelectedList,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmIgenyles_GetVizsgalatInfoText", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            //this.$refs.GRCDB.HideLoading();
            return;
        }

        this.VizsgalatInfoText = Q.RESULT[0].InfoText;

    },

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },


    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmIgenyles", pCompName);
    },

    SetLang()
    {
        this.MainStep0_infotext = this.GetTextBookItem("MainStep0_infotext");

    },

      SetControlToFocus(pNextComp)
      {
          if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
      },


    btnIdopont_Uj_click()
    {
        this.$refs.txtDatumTol.SetText("");
        this.$refs.txtDatumIg.SetText("");
        this.$refs.cboTimeTol.SetValue(0);
        this.$refs.cboTimeIg.SetValue(0);
        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.$refs.txtDatumIg.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.IdopontInputMode = 1;
    },

    btnIdopontMentes()
    {
        if ((this.$refs.txtDatumTol.GetText() == "")||(this.$refs.txtDatumIg.GetText() == ""))
        {
            this.ShowResult("A dátumok megadása kötelező!", 200);
            return;
        }

        if (this.$refs.txtDatumTol.IsValid(false) == false)
        {
            this.ShowResult("A kezdő dátum helytelen!", 200);
            return;
       }

        if (this.$refs.txtDatumIg.IsValid(false) == false)
        {
            this.ShowResult("A záró dátum helytelen!", 200);
            return;
       }

        if ((this.ELLCSOPSELECTED !="6")&&(this.ELLCSOPSELECTED !="9"))
        {
            if ((this.$refs.cboTimeTol.GetValue() == 0)||(this.$refs.cboTimeIg.GetValue() == 0))
            {
                this.ShowResult("Az időpontok megadása kötelező!", 200);
                return;
            }

            if (this.$refs.cboTimeIg.GetValue() - this.$refs.cboTimeTol.GetValue() < 6)
            {
                this.ShowResult("Kérjük legalább 3 órás időszakot adjon meg!", 200);
                return;
            }
        }


        var DTOL = this.$refs.txtDatumTol.GetText();
        var DIG = this.$refs.txtDatumIg.GetText();

        var TTOL = this.$refs.cboTimeTol.GetText();
        var TIG = this.$refs.cboTimeIg.GetText();

        if ((this.ELLCSOPSELECTED =="6")||(this.ELLCSOPSELECTED =="9"))
        {
            TTOL = "08:00";
            TIG = "20:00";
        }

        if (DTOL.localeCompare(DIG) == 1)
        {
            this.ShowResult("A dátumok megadása helytelen!", 200);
            return;
        }

        if (TTOL.localeCompare(TIG) == 1)
        {
            this.ShowResult("Az időpontok megadása helytelen!", 200);
            return;
        }


        var idopontitem = { DatumTol: DTOL, DatumIg: DIG, TimeTol: TTOL, TimeIg: TIG, TimeTolID: this.$refs.cboTimeTol.GetValue(), TimeIgID: this.$refs.cboTimeIg.GetValue()};

        this.Idopontok.push(idopontitem);


        this.IdopontInputMode = 0;
    },

    btnIdopontMegsem()
    {
        this.IdopontInputMode = 0;
    },

    IdopontTorles(pIndex)
    {
        this.Idopontok.splice(pIndex,1);
    },



      HideErrors()
      {
          this.$refs.txtPanaszokKezdete.HideError();
      },



      async btnStepTo(pStepIndex)
      {
          //console.log("from: "+this.innerform+"  to: "+pStepIndex);

          this.HideErrors();

          //pStepIndex = 4;
          if ((this.innerform == 5)&&(pStepIndex==10))
          {
              this.OnlineLehet = false;
              this.DokumentumKotelezo = 0;
              this.ELLCSOPSELECTED = "";
              this.JAROBETEGSELECTED = "";
              this.EllCsopSelectedText = "";
              this.JarobetegSelectedText = "";

              var SzakorvosiKivalasztva = false;
              var step5_EllOK = false;

              this.DokumentumKotelezo = this.$refs.chkKontrol.GetValue(); // ha kontrol, akkor mindenképpen kell dok feltöltés


              for(var i=0; i<this.ELLATASCSOPORT.length; i++)
              {
                  if (this.$refs.chkEllCsop[i].GetValue() == 1)
                  {
                      if (this.ELLATASCSOPORT[i].Beutalo == 1) { this.DokumentumKotelezo = 1; }
                      if (this.ELLATASCSOPORT[i].ID == 7) { SzakorvosiKivalasztva = true; }
                      else { step5_EllOK =true; }

                      if (this.ELLCSOPSELECTED != "") 
                      { 
                          this.ELLCSOPSELECTED = this.ELLCSOPSELECTED + ", "; 
                          this.EllCsopSelectedText = this.EllCsopSelectedText + ", ";
                      }

                      this.ELLCSOPSELECTED = this.ELLCSOPSELECTED + this.ELLATASCSOPORT[i].ID;
                      this.EllCsopSelectedText = this.EllCsopSelectedText + this.ELLATASCSOPORT[i].Megnevezes;
                  }
              }

              if (SzakorvosiKivalasztva)
              {
                  for(var i=0; i<this.JAROBETEGELLATAS.length; i++)
                  {
                      if (this.$refs.chkJarobeteg[i].GetValue() == 1)
                      {
                          step5_EllOK = true;
                        if (this.JAROBETEGELLATAS[i].Beutalo == 1) { this.DokumentumKotelezo = 1; }

                        if (this.JAROBETEGSELECTED != "") 
                        { 
                            this.JAROBETEGSELECTED = this.JAROBETEGSELECTED + ", "; 
                            this.JarobetegSelectedText = this.JarobetegSelectedText + ", ";
                        }

                        this.JAROBETEGSELECTED = this.JAROBETEGSELECTED + this.JAROBETEGELLATAS[i].ID;
                        this.JarobetegSelectedText = this.JarobetegSelectedText + this.JAROBETEGELLATAS[i].Megnevezes;
                      }
                  }
              }

              if (step5_EllOK == false)
              {
                this.ShowResult("Legalább egy vizsgálat kiválasztása kötelező!", 200);
                return;
              }

            var VL = this.$refs.txtVizsgalatLeiras.GetText();
            VL = VL.replace(/(\r\n|\n|\r)/gm, "");

            if (VL.length < 6)
            {
                this.ShowResult(this.txtVizsgalatLeiras_labeltext, 200);
                return;
            }

            if (this.ELLCSOPSELECTED == "6") // egynapos
            {
                if (this.MutetIntezTipus == 0)
                {
                    this.ShowResult("Kérjük adja meg a műtét szervezési módját!<br>(magam intézem vagy ellátásszervezőre bízom)", 200);
                    return;
                }

                if (this.MutetIntezTipus == 1) // magam intézem
                {
                    if (this.$refs.chkMutet_MagamIntezem_sub1.GetValue() == 0)
                    {
                        this.ShowResult("A műtét szervezési módhoz tartozó feltételek elfogadása kötelező!", 200);
                        return;
                    }
                }

                if (this.MutetIntezTipus == 2) // ellátásszervezőre bízom
                {
                    if ((this.$refs.chkMutet_Ella_sub1.GetValue() == 0) && ( this.chkMutet_Ella_Sub1_visible == 1))
                    {
                        this.ShowResult("A műtét szervezési módhoz tartozó feltételek elfogadása kötelező!", 200);
                        return;
                    }

                    if (this.$refs.chkMutet_Ella_sub2.GetValue() == 0)
                    {
                        this.ShowResult("A műtét szervezési módhoz tartozó feltételek elfogadása kötelező!", 200);
                        return;
                    }

                }

            }
            else
            {
                this.MutetIntezTipus = 0; // ha nem egynapos, akkor bármi lehet

                if (this.ELLCSOPSELECTED != "9") // nem ambulans
                {
                    if (this.$refs.chkKivizsgalas.GetValue() + this.$refs.chkKontrol.GetValue() + this.$refs.chkSzures.GetValue() == 0)
                    {
                        this.ShowResult("Kérjük adja meg a vizsgálat típusát!<br>(kivizsgálás, kontrol, szűrés)", 200);
                        return;
                    }
                }
            }




          } // from 5 to 10


          if ((this.innerform == 10)&&(pStepIndex==20))
          {
            var ErrorCompName = "";

            var PK = this.$refs.txtPanaszokKezdete.GetText();

            //if ((moment(PK,"YYYY.MM.DD").isValid() == false )||(PK.length!=10))
            if (this.$refs.txtPanaszokKezdete.IsValid(false) == false)
            {
                if (ErrorCompName == "") { ErrorCompName = "txtPanaszokKezdete"; }
                this.$refs.txtPanaszokKezdete.ShowError("A panasz kezdő dátuma nincs megadva vagy helytelen!");
            }
            else
            {
                if (PK.localeCompare(this.MinPanaszKezdet) == -1)
                {
                    if (ErrorCompName == "") { ErrorCompName = "txtPanaszokKezdete"; }
                    this.$refs.txtPanaszokKezdete.ShowError("A panasz kezdete nem lehet kisebb "+this.MinPanaszKezdet+" napnál!");
                }
                if (PK.localeCompare(this.MaxPanaszKezdet) == 1)
                {
                    if (ErrorCompName == "") { ErrorCompName = "txtPanaszokKezdete"; }
                    this.$refs.txtPanaszokKezdete.ShowError("A panasz kezdete nem lehet nagyobb "+this.MaxPanaszKezdet+" napnál!");
                }
            }

            if (ErrorCompName != "")
            {
                this.SetControlToFocus(ErrorCompName);
                return;
            }

            var PL = this.$refs.txtPanaszLeiras.GetText();
            PL = PL.replace(/(\r\n|\n|\r)/gm, "");

            if (PL.length < 30)
            {
                this.ShowResult("Kérjük röviden írja le panaszát!", 200);
                return;
            }

            if (this.DokumentumKotelezo == 0)
            {
                this.innerform = 20;
                this.btnStepTo(30);
                return;
            }


          }

          if ((this.innerform == 20)&&(pStepIndex==30))
          {

              if (this.$refs.docs.GetFileCount() == 0)
              {
                  if (this.DokumentumKotelezo == 1)
                  {
                    if ((this.ELLCSOPSELECTED=='6')||(this.ELLCSOPSELECTED=='9'))
                    {
                        this.ShowResult("A sebészeti ellátást csak orvosi javaslatra tudjuk engedélyezni, amennyiben nem rendelkezik orvosi javaslattal, kérjük szerezze be. Az ellátási igény bejelentését ezután végezze el.", 200);
                    }
                    else
                    {
                        this.ShowResult("Legalább egy dokumentum feltöltése kötelező!", 200);
                    }
                    return;
                  }
              }

            if ((this.ELLCSOPSELECTED=='6')&&(this.MutetIntezTipus==1))
            {
                if (this.$refs.docs2.GetFileCount() == 0)
                {
                    this.ShowResult("Ön a sebészeti ellátást saját szervezésben kívánja igénybe venni, amennyiben nem rendelkezik árajánlattal, kérjük szerezze be. Az ellátási igény bejelentését ezután végezze el.", 200);
                    return;
                }
            }

            this.$refs.chkIdopont1.SetReadonly(false);
            this.$refs.chkIdopont2_1.SetReadonly(false);
            this.$refs.chkIdopont2.SetReadonly(false);
            this.$refs.chkIdopont3.SetReadonly(false);

            this.$refs.chkIdopont1.SetValue(0);
            this.$refs.chkIdopont2.SetValue(0);
            this.$refs.chkIdopont2_1.SetValue(0);
            this.$refs.chkIdopont3.SetValue(0);

            this.$refs.txtVanIdopont_Datum.SetLabel("Dátum:");

            if ((this.ELLCSOPSELECTED=='6')||(this.ELLCSOPSELECTED=='9')) // sebeszet
            {
                this.$refs.txtVanIdopont_Datum.SetLabel("Műtét várható dátuma:");

                if (this.MutetIntezTipus==1)
                {
                    this.IdopontCheckboxSelected = 1;
                    this.$refs.chkIdopont1.SetValue(1);
                    this.$refs.chkIdopont1.SetReadonly(true);
                    this.$refs.chkIdopont2_1.SetReadonly(true);

                }
                if (this.MutetIntezTipus==2)
                {
                    this.$refs.chkIdopont3.SetValue(1);
                    this.$refs.chkIdopont2.SetReadonly(true);
                    this.$refs.chkIdopont3.SetReadonly(true);

                    //this.innerform = 35;
                    this.IdopontCheckboxSelected_2 = 2;                    
                    this.btnStepTo(35);
                    return;

                }
            }



          }          

          if ((this.innerform == 30)&&(pStepIndex==35))
          {
              if ((this.$refs.chkIdopont1.GetValue() == 0)&&(this.$refs.chkIdopont2_1.GetValue() == 0))
              {
                this.ShowResult("Kérjük válassza ki az időpont foglalás módját!", 200);
                return;
              }

              if (this.$refs.chkIdopont1.GetValue() == 1)
              {
                if (this.$refs.txtVanIdopont_Szolgaltato.GetText().trim().length < 5)
                {
                    this.ShowResult("Kérjük adja meg a szolgáltatót!", 200);
                    return;
                }

                if (this.$refs.txtVanIdopont_Datum.GetText() == '')
                {
                    this.ShowResult("Kérjük adja meg a dátumot!", 200);
                    return;
                }
                else
                {
                    if (this.$refs.txtVanIdopont_Datum.IsValid(false) == false)
                    {
                        this.ShowResult("A dátum helytelen!", 200);
                        return;
                    }
                }

                if ((this.ELLCSOPSELECTED!="6")&&(this.ELLCSOPSELECTED!="9"))
                {
                    if ((this.$refs.cboVanIdopont_Ora.GetValue() == 0) && (this.$refs.cboVanIdopont_Perc.GetValue() == 0))
                    {
                        this.ShowResult("Kérjük adja meg az időpontot!", 200);
                        return;
                    }
                }
              }

              if (this.$refs.chkIdopont2_1.GetValue() == 1)
              {
                  var VN = this.$refs.txtVarosOnline.GetText().trim().toLowerCase();
                  if (VN == "")
                  {
                    this.ShowResult("Kérjük adja meg a várost!", 200);
                    return;
                  }

                  var VarosOK = false;

                  for(var i=0; i<this.HELYSEGEK.length;i++)
                  {
                      if (VN == this.HELYSEGEK[i].Megnevezes.trim().toLowerCase())
                      {
                          VarosOK = true;
                          break;
                      }
                  }

                  if (VarosOK == false)
                  {
                    this.ShowResult("Kérjük válasszon a listában szereplő városok közül!", 200);
                    return;
                  }
              }

              if (this.$refs.chkIdopont1.GetValue() == 1) { this.DisplayOsszesito(); return; }
              if (this.$refs.chkIdopont2_1.GetValue() == 1) 
              { 
                // Medicall lekérdezés!!!

                this.$refs.GRCDB.ShowLoading(false);

                var QP = {
                    sSessionID: "[APPSESSIONID]",
                    sEllatasIDS: this.ELLCSOPSELECTED,
                    sJarobetegIDS: this.JAROBETEGSELECTED,
                    sVaros: this.$refs.txtVarosOnline.GetText(),
                };
                var Q;
                await this.$refs.GRCDB.GetData("frmIgenyles_MCLIST", QP).then(res => { Q = res; });

                if (Q.APPERR[0].ERR != "")
                {
                    this.$refs.GRCDB.HideLoading();

                    await this.ShowResult(Q.APPERR[0].ERR, 250);

                    res = false;
                }

                this.$refs.GRCDB.HideLoading();

                this.OnlineLehet = (Q.RESULT[0].OnlineLehet == 1);

                if (this.OnlineLehet == false)
                {
                    this.$refs.chkIdopont3.SetValue(1);
                }
                else
                {
                    this.$refs.chkIdopont3.SetValue(0);
                }
                //console.log(Q.RESULT[0].OnlineLehet);


                this.$refs.txtVarosEllatas.SetText(this.$refs.txtVarosOnline.GetText());
                this.innerform = 35;
              }

          }          

          if ((this.innerform == 35)&&(pStepIndex==40))
          {
              if ((this.$refs.chkIdopont2.GetValue() == 0)&&(this.$refs.chkIdopont3.GetValue() == 0))
              {
                this.ShowResult("Kérjük válasszon az opciók közül!", 200);
                return;
              }

              if (this.$refs.chkIdopont2.GetValue() == 1)
              {
                  // online választ
                  this.DisplayOsszesito();
                  return;
              }

              // itt chkIdopont3==1
              console.log("chk3: "+this.$refs.chkIdopont3.GetValue());

                  var VN = this.$refs.txtVarosEllatas.GetText().trim().toLowerCase();
                  if (VN == "")
                  {
                    this.ShowResult("Kérjük adja meg a várost!", 200);
                    return;
                  }

                  var VarosOK = false;

                  for(var i=0; i<this.HELYSEGEK.length;i++)
                  {
                      if (VN == this.HELYSEGEK[i].Megnevezes.trim().toLowerCase())
                      {
                          VarosOK = true;
                          break;
                      }
                  }

                  if (VarosOK == false)
                  {
                    this.ShowResult("Kérjük válasszon a listában szereplő városok közül!", 200);
                    return;
                  }
          }


          if ((this.innerform == 40)&&(pStepIndex==50))
          {
              if (this.Idopontok.length == 0)
              {
                this.ShowResult("Kérjük adjon meg legalább egy idősávot!", 200);
                return;
              }

              if (await this.CheckIdosavok() == false) { return; }

            this.DisplayOsszesito();

          }          

          if ((this.innerform == 40)&&(pStepIndex==35))
          {
            if (this.$refs.chkIdopont1.GetValue() == 1) { this.btnStepTo(30); return; }

            if ((this.ELLCSOPSELECTED=='6')||(this.ELLCSOPSELECTED=='9')) // sebeszet
            {
                if (this.MutetIntezTipus==2)
                {
                    //this.btnStepTo(20);
                    //return;
                }
            }
          }

          if ((this.innerform == 35)&&(pStepIndex==30))
          {
            if ((this.ELLCSOPSELECTED=='6')||(this.ELLCSOPSELECTED=='9')) // sebeszet
            {
                if (this.MutetIntezTipus==2)
                {
                    this.btnStepTo(20);
                    return;
                }
            }
          }

          if ((this.innerform == 50)&&(pStepIndex==40))
          {
              if (this.$refs.chkIdopont1.GetValue() == 1) { this.btnStepTo(30); return; }
              if (this.$refs.chkIdopont2.GetValue() == 1) { this.btnStepTo(35); return; }
              //if (this.$refs.chkIdopont3.GetValue() == 1) { this.btnStepTo(35); return; }
          }

          if ((this.innerform == 30)&&(pStepIndex==20))
          {
            if (this.DokumentumKotelezo == 0)
            {
                this.btnStepTo(10);
                return;
            }
          }





        this.innerform = pStepIndex;
        this.scrollToTop();

        var StepProgressValue = 1;

        if (pStepIndex == 5) { StepProgressValue = 1; }
        if (pStepIndex == 10) { StepProgressValue = 2; }
        if (pStepIndex == 20) { StepProgressValue = 3; }
        if (pStepIndex == 30) { StepProgressValue = 4; }
        if (pStepIndex == 35) { StepProgressValue = 4; }
        if (pStepIndex == 40) { StepProgressValue = 4; }
        if (pStepIndex == 50) { StepProgressValue = 5; }

        this.$refs.StepProgress.SetValue(StepProgressValue);
      },

      DisplayOsszesito()
      {
        this.Files = this.$refs.docs.GetFileNames();

        if (this.ELLCSOPSELECTED == "6")
        {
            let egynapos_files = this.$refs.docs2.GetFileNames();
            for(let i=0; i<egynapos_files.length; i++)
            {
                this.Files.push({FileName: egynapos_files[i].FileName});
            }
        }





        this.Osszesito.Igenylo = this.UgyfelNev;

        var PL = this.$refs.txtPanaszLeiras.GetText();
        PL = PL.replace(/(\r\n)/gm, "<br>");
        PL = PL.replace(/(\n|\r)/gm, "<br>");

        var VL = this.$refs.txtVizsgalatLeiras.GetText();
        VL = VL.replace(/(\r\n)/gm, "<br>");
        VL = VL.replace(/(\n|\r)/gm, "<br>");

        if ((this.ELLCSOPSELECTED != "6")&&(this.ELLCSOPSELECTED != "9"))
        {
            if (this.$refs.chkKivizsgalas.GetValue() == 1) { VL = VL + "<br><b>Kivizsgálás</b>"; }
            if (this.$refs.chkKontrol.GetValue() == 1) { VL = VL + "<br><b>Kontroll vizsgálat</b>"; }
            if (this.$refs.chkSzures.GetValue() == 1) { VL = VL + "<br><b>Szűrés célú vizsgálat</b>"; }
        }


        VL = VL + " ("+this.EllCsopSelectedText;
        if (this.JarobetegSelectedText != "")
        {
            VL = VL + ", "+this.JarobetegSelectedText;
        }
        VL = VL + ")";


        this.Osszesito.PanaszKezdet = this.$refs.txtPanaszokKezdete.GetText();
        this.Osszesito.PanaszLeiras = PL;
        this.Osszesito.VizsgalatLeiras = VL;
        
        this.Osszesito.VarosMegjegyzes = "";

        if (this.$refs.chkIdopont1.GetValue() == 1)
        {
            this.Osszesito.IdopontID = 1;
            this.Osszesito.Varos = "";
            this.Osszesito.IdopontMegnevezes = "Már van időpontom";

            this.Osszesito.VanIdopont_Szolgaltato = this.$refs.txtVanIdopont_Szolgaltato.GetText();
            if (this.$refs.txtVanIdopont_Orvos.GetText() != "")
            {
                this.Osszesito.VanIdopont_Szolgaltato = this.Osszesito.VanIdopont_Szolgaltato + " (orvos: "+this.$refs.txtVanIdopont_Orvos.GetText()+")";
            }

            this.Osszesito.VanIdopont_Idopont = this.$refs.txtVanIdopont_Datum.GetText();
            if ((this.ELLCSOPSELECTED != "6")&&(this.ELLCSOPSELECTED != "9"))
            {
                this.Osszesito.VanIdopont_Idopont = this.Osszesito.VanIdopont_Idopont +" "+this.$refs.cboVanIdopont_Ora.GetText()+":"+this.$refs.cboVanIdopont_Perc.GetText()
            }
        }

        if (this.$refs.chkIdopont2.GetValue() == 1)
        {
            this.Osszesito.IdopontID = 2;
            this.Osszesito.Varos = this.$refs.txtVarosOnline.GetText();
            this.Osszesito.IdopontMegnevezes = "Online intézem";
            this.Osszesito.VarosMegjegyzes = "";//this.$refs.txtVarosOnlineMegjegyzes.GetText();
        }

        if (this.$refs.chkIdopont3.GetValue() == 1)
        {
            this.Osszesito.IdopontID = 3;
            this.Osszesito.Varos = this.$refs.txtVarosEllatas.GetText();
            this.Osszesito.IdopontMegnevezes = "Ellátásszervezőre bízom";
            this.Osszesito.VarosMegjegyzes = this.$refs.txtVarosEllatasMegjegyzes.GetText();
        }

        this.Osszesito.Idosavok = "";

        if (this.Osszesito.IdopontID == 3)
        {
            for(var i=0; i<this.Idopontok.length; i++)
            {
                this.Osszesito.Idosavok = this.Osszesito.Idosavok
                + this.Idopontok[i].DatumTol+" - "+this.Idopontok[i].DatumIg;
                if ((this.ELLCSOPSELECTED != "6")&&(this.ELLCSOPSELECTED != "9"))
                {
                    this.Osszesito.Idosavok = this.Osszesito.Idosavok +"&nbsp;&nbsp;&nbsp;"+this.Idopontok[i].TimeTol+" - "+this.Idopontok[i].TimeIg;
                }

                if (i<this.Idopontok.length-1) { this.Osszesito.Idosavok = this.Osszesito.Idosavok + "<br>"; }
            }
        }

        this.innerform = 50;
        this.scrollToTop();
        this.$refs.StepProgress.SetValue(5);


      },


      async Mentes()
      {
          this.$refs.GRCDB.ShowLoading(false);


          var pFajlok = "";

          if (this.$refs.docs.GetFileCount() > 0)
          {
            var UploadRes = await this.$refs.docs.UploadFiles(1);
            if (UploadRes.Success == false) 
            { 
                this.$refs.GRCDB.HideLoading();
                await this.ShowResult("A dokumentum feltöltés előkészítése sikertelen!", 250);

                return;
            }
            
            pFajlok = pFajlok + "<DOCS>"
            +"<UploadID><![CDATA["+UploadRes.UploadID+"]]></UploadID>"
            +"<Megjegyzes><![CDATA["+UploadRes.Megjegyzes+"]]></Megjegyzes>"
            +"</DOCS>";

            pFajlok = "<NewDataSet>" + pFajlok + "</NewDataSet>";

          } // ha van fajl

          var pFajlok2 = "";
          
          if (this.ELLCSOPSELECTED == "6") //egynapos
          {
            if ((this.MutetIntezTipus==1)&&(this.$refs.docs2.GetFileCount() > 0))
            {
                var UploadRes = await this.$refs.docs2.UploadFiles(1);
                if (UploadRes.Success == false) 
                { 
                    this.$refs.GRCDB.HideLoading();
                    await this.ShowResult("A dokumentum feltöltés előkészítése sikertelen!", 250);
                    return;
                }
                
                pFajlok2 = pFajlok2 + "<DOCS>"
                +"<UploadID><![CDATA["+UploadRes.UploadID+"]]></UploadID>"
                +"<Megjegyzes><![CDATA["+UploadRes.Megjegyzes+"]]></Megjegyzes>"
                +"</DOCS>";

                pFajlok2 = "<NewDataSet>" + pFajlok2 + "</NewDataSet>";

            } // ha van fajl

          }

          let pVarosMegjegyzes = "";
          if ((this.Osszesito.IdopontID == 2) || (this.Osszesito.IdopontID == 3))
          {
            pVarosMegjegyzes = this.Osszesito.VarosMegjegyzes;
          }


          var pIdosavok = this.GetIdosavXml();
          

        //this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          iSzolgaltatasID: this.SzolgaltatasID,
          sPanaszKezdet: this.Osszesito.PanaszKezdet,
          sPanaszLeiras: this.Osszesito.PanaszLeiras,
          sVizsgalatLeiras: this.Osszesito.VizsgalatLeiras,
          sFajlok: pFajlok,
          iIdopontTipusID: this.Osszesito.IdopontID,
          sVaros: this.Osszesito.Varos,
          sIdosavok: pIdosavok,
          sVanIdopont_Szolgaltato: this.$refs.txtVanIdopont_Szolgaltato.GetText().trim(),
          sVanIdopont_Orvos: this.$refs.txtVanIdopont_Orvos.GetText().trim(),
          sVanIdopont_Datum: this.$refs.txtVanIdopont_Datum.GetText(),
          iVanIdopont_Ora: this.$refs.cboVanIdopont_Ora.GetValue(),
          iVanIdopont_Perc: this.$refs.cboVanIdopont_Perc.GetValue(),
          sEllatasIDS: this.ELLCSOPSELECTED,
          sJarobetegIDS: this.JAROBETEGSELECTED,
          sVarosMegjegyzes: pVarosMegjegyzes,
          sFajlok2: pFajlok2,

        };
        var Q;
        await this.$refs.GRCDB.GetData("frmIgenyles_Save", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 250);

            return;
        }

        this.$refs.GRCDB.HideLoading();

        await this.ShowResult(Q.RESULT[0].strResult, 350).then(res => 
        { 
            if (Q.RESULT[0].intResult == 1)
            {
                document.location = "dashboard";
            }
        });               

      },

      GetFajlXml()
      {
        if (this.Files.length == 0) { return ""; }

        var res = "<NewDataSet>";
        for(var i=0; i<this.Files.length; i++)
        {
            var ext = grcmain_getFileExtension(this.Files[i].filename.toLowerCase());
            if (ext == "jpeg") { ext = "jpg"; }

            res = res 
            +"<FAJL>"
            + "<FajlNev>"+this.Files[i].filename+"</FajlNev>"
            + "<FajlAdat>"+this.Files[i].ResizedData+"</FajlAdat>"
            + "<Kiterjesztes>"+ext+"</Kiterjesztes>"
            +"</FAJL>";
        }
        res = res + "</NewDataSet>";

        return res;
      },




      GetIdosavXml()
      {
        var res = "<NewDataSet>";
        for(var i=0; i<this.Idopontok.length; i++)
        {
            res = res 
            +"<IDOSAV>"
            + "<DatumTol>"+this.Idopontok[i].DatumTol+"</DatumTol>"
            + "<DatumIg>"+this.Idopontok[i].DatumIg+"</DatumIg>"
            + "<IdoTol>"+this.Idopontok[i].TimeTol+"</IdoTol>"
            + "<IdoIg>"+this.Idopontok[i].TimeIg+"</IdoIg>"
            +"</IDOSAV>";
        }
        res = res + "</NewDataSet>";

        return res;
      },

      async CheckIdosavok()
      {
          var res = true;

          var pIdosavok = this.GetIdosavXml();


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          iSzolgaltatasID: this.SzolgaltatasID,
          sIdosavok: pIdosavok,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmIgenyles_CheckIdosavok", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 250);

            res = false;
        }

        this.$refs.GRCDB.HideLoading();

        return res;
      },





      btnMentes()
      {
          this.Mentes();
      },

      chkIdopontClick_2(pID)
      {
          //console.log("chk click "+pID);

          if ((pID == 1)&&(this.$refs.chkIdopont2.GetValue() == 1))
          {
            this.$refs.chkIdopont3.SetValue(0);
            return;
          }

          if ((pID == 2)&&(this.$refs.chkIdopont3.GetValue() == 1))
          {
            this.$refs.chkIdopont2.SetValue(0);
            return;
          }

          this.IdopontSelected = -1;
          this.IdopontCheckboxSelected_2 = 0;
          if (this.$refs.chkIdopont2.GetValue() == 1) { this.IdopontSelected = 2; this.IdopontCheckboxSelected_2 = 1; }
          if (this.$refs.chkIdopont3.GetValue() == 1) { this.IdopontSelected = 3; this.IdopontCheckboxSelected_2 = 2; }
      },

      chkIdopontClick(pID)
      {
          //console.log("chk click "+pID);

          if ((pID == 1)&&(this.$refs.chkIdopont1.GetValue() == 1))
          {
            this.$refs.chkIdopont2_1.SetValue(0);
            return;
          }

          if ((pID == 2)&&(this.$refs.chkIdopont2_1.GetValue() == 1))
          {
            this.$refs.chkIdopont1.SetValue(0);
            return;
          }


          this.IdopontSelected = -1;
          this.IdopontCheckboxSelected = 0;
          if (this.$refs.chkIdopont1.GetValue() == 1) 
          { 
              this.IdopontSelected = 1;
              this.IdopontCheckboxSelected = 1; 
        }

          if (this.$refs.chkIdopont2_1.GetValue() == 1) { this.IdopontSelected = 23; this.IdopontCheckboxSelected = 2; }

          //this.IdopontCheckboxSelected = IdopontSelected;

      },


      async Init()
      {
        this.DokumentumKotelezo = 0;
        this.ShowJarobeteg = false;
        this.ShowKontrolInfo = false;
        this.KontrolInfoText = "";
        this.ELLCSOPSELECTED = "";
        this.JAROBETEGSELECTED = "";
        this.EllCsopSelectedText = "";
        this.JarobetegSelectedText = "";
  

        //this.$refs.StepProgress.Init([ {text:"Panaszok"}, {text:"Orvosi dokumentumok feltöltése"}, {text:"Hely és időpont megadása"}, {text:"Áttekintés"} ]);
        this.$refs.StepProgress.Init([ {text: "Igényelt vizsgálat"},  {text:"Panaszok"}, {text:"Orvosi dokumentumok feltöltése"}, {text:"Hely és időpont megadása"}, {text:"Áttekintés"} ]);
        

        
        this.UgyfelID = gDashboardUgyfelID;


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: this.UgyfelID,
          iSzolgaltatasID: this.SzolgaltatasID,
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmIgenyles_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowResult(Q.APPERR[0].ERR, 250);

            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.UgyfelNev = Q.RESULT[0].UgyfelNev;

        if (Q.RESULT[0].IsEnabled == 0)
        {
            this.IsEnabled = 0;
            this.DisabledText = Q.RESULT[0].DisabledText;
            return;
        }

        this.IsEnabled = Q.RESULT[0].IsEnabled;


        this.ELLATASCSOPORT = Q.ELLATASCSOPORT;
        this.JAROBETEGELLATAS = Q.JAROBETEGELLATAS;
        this.HELYSEGEK = Q.HELYSEGEK;

        this.KontrolInfoText = Q.RESULT[0].KontrolInfoText;

        this.Varos = Q.RESULT[0].Varos;
        this.SzolgaltatasNev = Q.RESULT[0].SzolgaltatasNev;
        this.MinPanaszKezdet = Q.RESULT[0].MinPanaszKezdet;
        this.MaxPanaszKezdet = Q.RESULT[0].MaxPanaszKezdet;

        this.chkMutet_Ella_Sub1_visible = Q.RESULT[0].chkMutet_Ella_Sub1_visible;

        //this.DokumentumKotelezo = Q.RESULT[0].DokumentumKotelezo;

        this.$refs.txtVarosOnline.SetDataSource(this.HELYSEGEK);
        this.$refs.txtVarosEllatas.SetDataSource(this.HELYSEGEK);

        this.$refs.cboTimeTol.SetDataSource(Q.IDOPONTOK);
        this.$refs.cboTimeIg.SetDataSource(Q.IDOPONTOK);


        this.$refs.cboVanIdopont_Ora.SetDataSource(Q.ORA);
        this.$refs.cboVanIdopont_Perc.SetDataSource(Q.PERC);

        this.$refs.cboVanIdopont_Ora.SetValue(0);
        this.$refs.cboVanIdopont_Perc.SetValue(0);

        //this.$refs.cboUgyfel.SetValue(gDashboardUgyfelID);


        

        this.MinDate = Q.MISC[0].MinDate;
        this.MaxDate = Q.MISC[0].MaxDate;

        this.$refs.txtDatumTol.SetMinMaxDate(this.MinDate, this.MaxDate);
        this.$refs.txtDatumIg.SetMinMaxDate(this.MinDate, this.MaxDate);
        

        this.innerform = 5;


      },


    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
            //this.Init();
        });               
    },


  },
  created()
  {

  },
  mounted()
  {
    if (gAppInitDone)
    {
      this.SetLang();
      this.Init();
    }
  }

}


</script>


<style scoped>

.igenypage_header
{
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    margin-bottom: 20px;

    background-color: var(--premgreen);
    color: #fff;
    font-weight: normal;
    display: inline-block;
    padding: 8px;
    border-radius: 3px;    
    margin-left: 10px;
}


.innerform_cont
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding:0px;
}

.innerform_col50
{
    width:50%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding:0px 0px;
    vertical-align: top;
    display:inline-block;
}



.innerform_header
{
    width:100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;
    padding: 8px 8px;
    background-color: var(--premblue);
    color: #fff;    
    margin-bottom:20px;
    border-radius: 3px;
}

.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}

.StepProgress_cont
{
    width:100%;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding:0px 8px;
}

.igeny_pageheader
{
    width:100%;
    box-sizing: border-box;
    margin-top:10px;
}

.igeny_pageheader_col1
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
}

.igeny_pageheader_col2
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
    text-align: right;
    padding-right: 8px;
    padding-top:30px;
}

.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'CmsDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;

}

.btn:hover
{
  background-color: var(--premgreen);
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
    background-color: #ddd;
    color: #444;;
}

.btn_gray:hover
{
    background-color: var(--premgreen);
    color: #fff;;
}




.filelist_cont {
    width: 100%;
    box-sizing: border-box;
    font-family: "CmsDefault";
    font-size: 15px;
    line-height: 18px;    
    color:var(--premblue);
    display: inline-block;
    border-bottom: solid 0px #ccc;
    padding-bottom: 4px;
    margin-bottom: 4px;
    text-align: center;
}

.file_for 
{
    width: 310px;
    box-sizing: border-box;
    display: inline-block;
    border:solid 1px #ccc;
    border-radius: 2px;
    margin:5px;
    box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    position: relative;
}

.file_for:hover
{
    background-color: #f6f6f6;
}

.file_thumb
{
    width: 100%;
    cursor:pointer;
    text-align: center;
    padding: 5px;
    width:300px;
    height:220px;
    position: relative;
}

.file_footer
{
    width: 100%;
    box-sizing: border-box;
    background-color: #f0f0f0;
    border-top:solid 1px #ccc;
    height: 40px;
    padding:4px;
}

.file_filename
{
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 16px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;    
    overflow: hidden;
}

.file_filesize
{
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 16px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;    
    overflow: hidden;
}

.file_delete
{
    width:30px;
    background-color: var(--premblue);
    color: #fff;
    position:absolute;
    right:-1px;
    top:-1px;
    text-align: center;
    padding: 8px;
    font-size: 16px;
    line-height: 16px;
    border-radius: 2px;
    cursor:pointer;
    z-index: 500;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}

.file_delete:hover
{
    background-color: var(--premgreen);
}

.UjIdopont_cont
{
    width: 100%;
    box-sizing: border-box;
    max-width: 600px;
    margin: 0px auto;
    padding: 4px;
    border: solid 1px #ccc;
    -webkit-box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    box-shadow: rgb(221, 221, 221) 2px 2px 4px;
    background-position: 0px 22px;
    border-radius: 3px;    
}

.UjIdopont_mezo
{
    width:50%;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    padding: 5px;    
}

.infotext
{
    width:100%;
    box-sizing: border-box;
}

.idopont_cont
{
    width:100%;
    box-sizing: border-box;
}

.idopont_item
{
    width:100%;
    box-sizing: border-box;
    padding: 8px 4px;
    border:solid 1px #ccc;
    border-radius: 3px;
    margin-bottom: 10px;
    background-color: #f6f6f6;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;    
    -webkit-box-shadow: #ddd 2px 2px 4px;
    box-shadow: 2px 2px 4px #ddd;    
}

.idopont_item:hover
{
    background-color: #f0f0f0;
}

.idopont_item_text
{
    width:100%;
}

.idopont_checkbox_cont
{
    width:100%;
    box-sizing: border-box;
    max-width: 2000px;
    margin-left: auto;
    margin-right: auto;
}

.igeny_pagecontent
{
    width:100%;
    box-sizing: border-box;
    margin: 0px auto;
}

.longlabel
{
    box-sizing: border-box;
    font-family: "CmsDefault", Verdana;
    font-size: 14px;
    line-height: 18px;
    color: #222;
    font-weight: bold;
    width:100%;    
}

.general_infotext
{
    width: 100%;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
}

.IdopontInput_row
{
    width:100%;
    box-sizing: border-box;
    max-width: 600px;
    margin:0px auto;
}

.idopont_list_header
{
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    font-weight: normal;
    text-align: left;

    background-color: var(--premgreen);
    color: #fff;
    font-weight: normal;
    display: inline-block;
    padding: 8px;
    border-radius: 3px;    
    margin-bottom: 10px;
    width:100%;
    max-width: 600px;
}


.osszesito_box_cont
{
    width:100%;
    box-sizing: border-box;
}

.osszesito_box_col
{
    width:50%;
    box-sizing: border-box;
    margin:0px;
    padding: 10px 10px 10px 0px;
    display:inline-block;
    vertical-align: top;
}

.osszesito_box_col_header
{
    width:100%;
    box-sizing: border-box;
    font-weight: 500;
}

.osszesito_box_col_content
{
    width:100%;
    box-sizing: border-box;
    font-weight: normal;
}


.igenyles_longlabel
{
    width:100%;
    box-sizing: border-box;
    font-weight: bold;
    font-size:13px;
    line-height: 16px;;
}

.kontrol_info
{
    width:100%;
    box-sizing: border-box;
    font-weight: normal;
    font-size:14px;
    line-height: 18px;
    font-family: 'CmsDefault';
    text-align: justify;
    color: #444;
}

.ellcsop_jarobeteg_megnev
{
    text-align:left; 
    font-family:'CmsDefault'; 
    font-size:15px; 
    line-height:20px; 
    color:#222;
    padding-top: 0px; 
    height: 30px; 
    font-weight: 500;    
}

.ellcsop_jarobeteg_megnev_disabled
{
    text-align:left; 
    font-family:'CmsDefault'; 
    font-size:15px; 
    line-height:20px; 
    color:#ccc;
    padding-top: 0px; 
    height: 30px; 
    font-weight: 500;    
}

.VizsgalatInfoText
{
    width:100%;
    box-sizing: border-box;
    padding: 4px;
    border: solid 1px #ccc;
    border-radius: 3px;
    background-color: #f3f4f5;
    color: #222;
    font-size: 14px;
    line-height: 18px;    
    text-align: justify;
}

>>>.VizsgalatInfoText_Header
{
    font-size: 15px;
    line-height: 15px;
    font-weight: 500;
    color: var(--themecolor3);
    padding: 6px 6px 4px 0px;
    border-radius: 3px;
    margin: 4px 0px;    
    display:inline-block;
    box-sizing: border-box;
}

.docs_label
{
    width: 100%;
    box-sizing: border-box;
    font-weight: 500;
    text-align: center;
    color: #222;    
}

.btnEllCsopInfo
{
    font-size: 15px;
    line-height: 15px;
    color: var(--premblue);
    padding: 6px 6px 4px 6px;
    margin-left:0px;
    cursor:pointer;
}

.btnEllCsopInfo:hover
{
    color: var(--premgreen);
}


@media (max-width:800px)
{
    .innerform_cont
    {
        padding:0px;
    }

    .igeny_pageheader_col1
    {
        width:100%;
    }

    .igeny_pageheader_col2
    {
        width:100%;
        text-align: left;
    }

}

@media (max-width:670px)
{
    .filelist_cont
    {
        text-align: center;
    }

    .osszesito_box_col
    {
        width:100%;
        margin-bottom:10px;
    }

    .innerform_col50
    {
        width:100%;
    }

}



</style>